import { useState } from "react";
import { Linkedin, Twitter, Mail, Copy, Check } from "lucide-react";

/**
 * Social share row for the Cash Flow Health Check report.
 * Generates platform-specific share URLs with a punchy auto-text
 * featuring the user's health score — turns every lead into a viral loop.
 */
export default function ShareButtons({ shareUrl, score, company }) {
  const [copied, setCopied] = useState(false);

  const headline = `I just scored ${score}/100 on SmartERP's free Cash Flow Health Check`;
  const blurb = `${headline} — instant AI report on runway, AR/AP and 3 prioritized actions.`;

  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
  const twitter = `https://twitter.com/intent/tweet?text=${encodeURIComponent(blurb)}&url=${encodeURIComponent(shareUrl)}&hashtags=SmartERP,CashFlow`;
  const mail = `mailto:?subject=${encodeURIComponent(headline)}&body=${encodeURIComponent(blurb + "\n\n" + shareUrl)}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.error("ShareButtons: clipboard.writeText failed", err);
    }
  };

  const btn = "flex-1 min-w-[120px] flex items-center justify-center gap-2 px-4 py-3 border border-zinc-950 bg-white text-xs font-semibold uppercase tracking-wider hover:bg-zinc-950 hover:text-white transition-colors";

  return (
    <div data-testid="share-buttons" className="border-t border-zinc-950 bg-zinc-50 px-6 py-5">
      <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 mb-3">
        / SHARE_YOUR_SCORE — {company ? `Show ${company} your ${score}/100` : `${score}/100`}
      </div>
      <div className="flex flex-wrap gap-2">
        <a
          data-testid="share-linkedin"
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className={btn}
        >
          <Linkedin size={14} /> LinkedIn
        </a>
        <a
          data-testid="share-twitter"
          href={twitter}
          target="_blank"
          rel="noopener noreferrer"
          className={btn}
        >
          <Twitter size={14} /> X · Twitter
        </a>
        <a
          data-testid="share-email"
          href={mail}
          className={btn}
        >
          <Mail size={14} /> Email
        </a>
        <button
          data-testid="share-copy"
          onClick={copyLink}
          className={btn}
          type="button"
        >
          {copied ? <Check size={14} /> : <Copy size={14} />}
          {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
}
